module.exports = __webpack_public_path__ + "static/media/pla_white_strew3.ea61f9a9.png";